jQuery(function($) {
	'use strict';

	var $slider = $( '.slider' );

	if ( 0 < $slider.length ) {
		$slider.slick({
			autoplay: false,
			autoplaySpeed: 10000,
			arrows: false,
			dots: true
		});
	}

	var videosStarted = false;

	$( window ).load( function() {

		if( videosStarted === false ) {

			$( this ).on( 'resize', function() {

				if( $( this ).width() > 992 ) {
					initializeYoutubeVideos();
					videosStarted = true;
				}

			} ).resize();

		}

	} );

	function initializeYoutubeVideos() {

		$( '.slick-slide:not(.slick-cloned) .youtube-video-container' ).each( function() {

			var YTcontainer = $( this );
			var YTcontainerID = YTcontainer.find( '[id^="youtube-video-container"]' ).attr('id');
			var videoID = YTcontainer.data('video-id');
			var cover = YTcontainer.find( '.cover' );
			prepareVideo( YTcontainerID, videoID, cover );

		} );

	}

	function prepareVideo( container, videoID, cover ) {
		var player;
		if((typeof YT !== "undefined") && YT && YT.Player){
			player = new YT.Player( container, {
			    videoId: videoID, // YouTube Video ID
				width: 1920,               // Player width (in px)
				height: 1080,              // Player height (in px)
				playerVars: {
					autoplay: 1,        // Auto-play the video on load
					controls: 0,        // Show pause/play buttons in player
					showinfo: 0,        // Hide the video title
					modestbranding: 1,  // Hide the Youtube Logo
					loop: 1,            // Run the video in a loop
					fs: 1,              // Hide the full screen button
					cc_load_policy: 0, // Hide closed captions
					iv_load_policy: 0,  // Hide the Video Annotations
					autohide: 0         // Hide video controls when playing
				},
				events: {
					onReady: function(e) {
						e.target.mute();
					},
					onStateChange: function( e ) {

						if ( e.data == YT.PlayerState.PLAYING ) {
							cover.fadeOut();
						}
						if ( e.data === YT.PlayerState.ENDED ) {
							player.playVideo();
						}
					}
				}
			});
		} else {
			setTimeout(prepareVideo, 100);
		}
	   }

	var $carousel = $( '.fp-section--blog .carousel' ),
		$tips = $( '.fp-section--tips .wrapper-inner');

	if ( 0 < $carousel.length ) {
		$carousel.slick({
			autoplay: true,
			autoplaySpeed: 30000,
			arrows: false,
			dots: true,
			mobileFirst: false,
			slidesToShow: 3,
			slidesToScroll: 3,
			responsive: [
				{
					breakpoint: 767,
					settings: "unslick"
				}
			]
		});
	}

	if ( 0 < $tips.length ) {
		$tips.slick({
			arrows: true,
			dots: true,
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 767,
					settings: 'unslick'
				}
			]
		});
	}
});
